import Colors from './Colors';
import Spacing from 'material-ui/styles/spacing';

const Theme = {
	spacing: Spacing,
	userAgent: false,
	palette: {
		primary1Color: Colors.sipgateBlack,
		primary2Color: Colors.sipgateWhite,
		primary3Color: Colors.sipgateGray,
		errorColor: Colors.errorColor,
	},
};

export default Object.assign(Theme);



// WEBPACK FOOTER //
// ./src/styles/theme.js